import React, { useState } from 'react'
import initialFAQs from 'utils/plus-faqs'
import { Link } from 'gatsby'

import { borderColor } from 'styles/colors'

import MetaTags from 'components/MetaTags'
import Layout from 'layouts/Layout'
import Header from 'components/vype-plus/PlusHeader'
import Benefits from 'components/vype-plus/Benefits'
import Search from 'components/vype-plus/Search'
import Faq from 'components/vype-plus/Faq'
import Features from 'components/vype-plus/Features'
import Video from 'components/vype-plus/Video'

const VypePlus = () => {
  const [faqs, setFaqs] = useState(initialFAQs)

  const setCategoryExpanded = (i, expanded) => {
    let newFaqs = [...faqs]
    newFaqs[i].expanded = expanded
    setFaqs(newFaqs)
  }

  const setQuestionExpanded = (i, j, expanded) => {
    let newFaqs = [...faqs]
    newFaqs[i].content[j].expanded = expanded
    setFaqs(newFaqs)
  }

  const navigateTo = ({ categoryIdx, questionIdx }) => {
    setCategoryExpanded(categoryIdx, true)
    setQuestionExpanded(categoryIdx, questionIdx, true)
    setTimeout(() => {
      window.location.hash = `#question-${categoryIdx}-${questionIdx}`
    }, 10)
  }

  return (
    <Layout hideHeader>
      <MetaTags
        title="Vuse Plus Rewards Program ➡️ Subscribe Online | By Vuse"
        description="Get the most out of your Vuse experience with exclusive offers, rewards 🎁, reductions and more! Subscribe and get up to 30% off pods and free shipping!  Previously govype.ca"
      />
      <div
        css={`
          background-color: #252a33;
          color: ${borderColor};
        `}
      >
        <Header />
        <Video />
        <Features />
        <Benefits />
        <Search faqs={faqs} navigateTo={navigateTo} />
        <Faq
          faqs={faqs}
          setCategoryExpanded={setCategoryExpanded}
          setQuestionExpanded={setQuestionExpanded}
          backgroundColor="#15171e"
          disclaimer={
            <span>
              For full terms and conditions of the Vuse+ program, <Link to="/pages/terms-conditions/">click here</Link>.
            </span>
          }
        />
      </div>
    </Layout>
  )
}

export default VypePlus
